const lang = localStorage.getItem('lang') || 'id'
import { date } from 'quasar'

const dayNames = {
  id: [
    'Minggu',
    'Senin',
    'Selasa',
    'Rabu',
    'Kamis',
    'Jumat',
    'Sabtu'
  ]
}

const monthNames = {
  id: [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember'
  ]
}

export const commonDate = (options) => {
  let {
    date,
    useDayName = false,
    useTime = false,
    dayNameOnly = false,
    hideYear = false,
    abbreviatedMonth = false // SORTEN MONTH NAME, ex: Desember -> Des
  } = options
  if (!date) return '-'

  date = new Date(date)

  if (isNaN(date)) return '-'

  let time = ''
  let dayName = ''

  if (dayNameOnly) return dayNames[lang][date.getDay()]

  if (useDayName) {
    dayName = dayNames[lang][date.getDay()] + ', '
  }

  if (useTime) {
    time = ' - ' +
      ('00' + date.getHours()).slice(-2) + ':' +
      ('00' + date.getMinutes()).slice(-2) + ':' +
      ('00' + date.getSeconds()).slice(-2)
  }

  let _date =
    dayName +
    ('00' + date.getDate()).slice(-2) + ' ' +
    (
      abbreviatedMonth && !!abbreviatedMonth
        ? monthNames[lang][date.getMonth()].slice(0, 3)
        : monthNames[lang][date.getMonth()]
    )

  if (!hideYear) {
    _date += ' ' + date.getFullYear()
  }

  _date += time

  return _date
}

export const dateYYYYMMDD = (value, separator = '/') => {
  if (value && !!value) {
    const timeStamp = new Date(value).getTime()
    return date.formatDate(timeStamp, 'YYYY' + separator + 'MM' + separator + 'DD')
  }
}

export const dateDDMMMYYYY = (value, separator = ' ') => {
  const newDate = date.formatDate(value, 'DD' + separator + 'MMM' + separator + 'YYYY')
  return newDate
}

export const dateSqlDateTime = (value, separator = ' ', timeSeparator = ':') => {
  const timeStamp = new Date(value).getTime()
  return date.formatDate(timeStamp, 'YYYY-MM-DD' + separator + `HH${timeSeparator}mm${timeSeparator}ss`)
}

export const dateTime = (value, timeSeparator = ':') => {
  const timeStamp = new Date(value)

  // return date.formatDate(timeStamp, `HH${timeSeparator}mm${timeSeparator}ss`)
  return ('00' + timeStamp.getHours()).slice(-2) + ':' +
    ('00' + timeStamp.getMinutes()).slice(-2) + ':' +
    ('00' + timeStamp.getSeconds()).slice(-2)
}

export const dayName = value => {
  return dayNames[lang][new Date(value).getDay()]
}

export const daysBetween = (dateStart, dateEnd) => {
  const ONE_DAY = 1000 * 60 * 60 * 24
  const differenceMs = dateEnd - dateStart
  return Math.round(differenceMs / ONE_DAY)
}
